import { Stack, Divider } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, PaymentLinkRow } from '@woovi/ui';

import type { PaymentLinkActiveInterestsSettings_charge$key } from './__generated__/PaymentLinkActiveInterestsSettings_charge.graphql.ts';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';

import type { ReactNode } from 'react';

type PaymentLinkActiveInterestsSettingsProps = {
  charge: PaymentLinkActiveInterestsSettings_charge$key;
};
const PaymentLinkActiveInterestsSettings = (
  props: PaymentLinkActiveInterestsSettingsProps,
): ReactNode => {
  const { t } = useTranslation();
  const charge = useFragment<PaymentLinkActiveInterestsSettings_charge$key>(
    graphql`
      fragment PaymentLinkActiveInterestsSettings_charge on Charge {
        value
        interestsSettings {
          active
        }
        decodedBrCode {
          interests
          fines
          rebate
          discount
          finalValue
        }
        paymentMethods {
          ... on PaymentMethodPix {
            value
          }
        }
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { value } = charge;
  const { fines, interests, finalValue, rebate, discount } = charge?.decodedBrCode || {};

  if (!charge?.interestsSettings?.active) {
    return null;
  }

  if (!interests && !fines && !finalValue) {
    return null;
  }

  return (
    <Stack sx={{ ml: 'auto', mr: 'auto', flexDirection: 'column', gap: 1, mt: 5, width: '80%' }}>
      <PaymentLinkRow title={t('Original value')} value={value} />

      {!!interests && (
        <PaymentLinkRow title={t('Interests')} value={interests} />
      )}

      {!!fines && <PaymentLinkRow title={t('Fines')} value={fines} />}

      <Divider />

      <PaymentLinkRow title={t('Total')} value={finalValue} />
    </Stack>
  );
};

export default PaymentLinkActiveInterestsSettings;
